export enum MalnutritionLevel {

    LEVEL_1 = 'SD3-',
    LEVEL_2 = 'SD2-',
    LEVEL_3 = 'SD1-',
    LEVEL_4 = 'SD0',
    LEVEL_5 = 'SD1',
    LEVEL_6 = 'SD2',
    LEVEL_7 = 'SD3',
    SEVERE_ACUTE_MALNUTRITION = 'severe-acute-malnutrition',
    ACUTE_MALNUTRITION = 'acute-malnutrition',
    MODERATE_ACUTE_MALNUTRITION = 'moderate-acute-malnutrition',
    RISK_OF_ACUTE_MALNUTRITION = 'risk-of-acute-malnutrition',
    OUTSIDE_OF_RISK_ZONE = 'outside-risk-zone',
    OUTSITE_OF_RISK_ZONE = 'outsite-risk-zone', // Wrong value from old versions
    HEALED = 'healed',
    NO_MEASURED = 'no-measured',
    UNKNOWN_LEVEL = 'none'


}
